import { createSlice } from '@reduxjs/toolkit';
import { fetchDefaultPriceConfig } from '../actions/default.config.action';

const initialState = {
  vnConfig: {
    priceConfig: { data: {}, isLoading: false, isNeedReloadData: false },
    profitConfig: { data: {}, isLoading: false, isNeedReloadData: false },
    ruleConfig: { data: {}, isLoading: false, isNeedReloadData: false },
  },
  usConfig: {
    priceConfig: { data: {}, isLoading: false, isNeedReloadData: false },
    profitConfig: { data: {}, isLoading: false, isNeedReloadData: false },
    ruleConfig: { data: {}, isLoading: false, isNeedReloadData: false },
  },
};

export const defaultConfigReducer = createSlice({
  name: 'DefaultConfig',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchDefaultPriceConfig.pending, (state, action) => {
        const arg = action.meta.arg;
        const currentState = state[(arg?.country_code ?? 'vn') + 'Config'];
        state[(arg?.country_code ?? 'vn') + 'Config'] = {
          priceConfig: {
            ...currentState.priceConfig,
            isLoading: true,
            isNeedReloadData: false,
          },
          profitConfig: {
            ...currentState.profitConfig,
            isLoading: true,
            isNeedReloadData: false,
          },
          ruleConfig: {
            ...currentState.ruleConfig,
            isLoading: true,
            isNeedReloadData: false,
          },
        };
      })
      .addCase(fetchDefaultPriceConfig.fulfilled, (state, action) => {
        const data = action.payload.data;
        if (data) {
          const arg = action.meta.arg;
          const currentState = state[(arg?.country_code ?? 'vn') + 'Config'];
          state[(arg?.country_code ?? 'vn') + 'Config'] = {
            priceConfig: {
              ...currentState.priceConfig,
              isLoading: false,
              data: data.price,
            },
            profitConfig: {
              ...currentState.profitConfig,
              isLoading: false,
              data: data.profit,
            },
            ruleConfig: {
              ...currentState.ruleConfig,
              isLoading: false,
              data: data.rule,
            },
          };
        } else {
        }
      })
      .addCase(fetchDefaultPriceConfig.rejected, (state, action) => {
        const arg = action.meta.arg;
        const currentState = state[(arg?.country_code ?? 'vn') + 'Config'];
        state[(arg?.country_code ?? 'vn') + 'Config'] = {
          priceConfig: {
            ...currentState.priceConfig,
            isLoading: false,
          },
          profitConfig: {
            ...currentState.profitConfig,
            isLoading: false,
          },
          ruleConfig: {
            ...currentState.ruleConfig,
            isLoading: false,
          },
        };
      });
  },
});
export default defaultConfigReducer.reducer;
